//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class FeatureService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[Feature.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/feature/create', params || { });
	};

	//GeneratorFlag:[Feature.Delete]
	async delete(featureId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:featureId
		}
	
		return await _server.delete('/store/feature/delete', {'params':params})
	};

	//GeneratorFlag:[Feature.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/feature/detail', {'params':params});
	};

	//GeneratorFlag:[Feature.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/feature/list', {'params':params});
	};

	//GeneratorFlag:[Feature.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/feature/update', params || { });
	};

//GeneratorFlag:[NewAction]
}